import * as React from "react";
import {UIState} from "../../data/UIState";
import './UnderLogin.pcss';

export const UnderLogin = () =>
  <div className="under-login">
    <p className="for-customer">Wellness Concepts for {UIState.settings.COMPANY_NAME}</p>
    {UIState.settings.CUSTOMER_LOGO &&
      <img
        src={`/res_customer/${UIState.settings.INSTALL_SUBDOMAIN}_LOGO.png`}
        className="customer-logo"
        alt={`${UIState.settings.COMPANY_NAME} logo`}
      />
    }

    <footer>
      <a target="_blank" href={"accessibility.html"}>Accessibility</a>
      <a target="_blank" href={UIState.settings.TOS_DOC}>Privacy Policy</a>
      <a href="mailto:strive@well-concepts.com?subject=Strive Portal Help">Need help? Email: strive@well-concepts.com</a>
    </footer>

  </div>
;
